import { Container, Modal, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import ModalBody from 'react-bootstrap/ModalBody';
import GenericList, { GenericListItem } from '../../../components/GenericList';
import Link from '../../../components/Link/Link';
import ModalHeader from '../../../components/ModalHeader';

export type RecentTransactionsModalProps = {
  showRecentTransactionsModal: boolean;
  handleCloseRecentTransactionsModal: () => void;
  data: {
    transactionType: string;
    confirmationNumber: string;
    submittedOn: string;
    createdVia: string;
    status: string;
    statusTooltipInfo: string;
    effective: string;
    planName: string;
    planType: string;
    taxableState: string;
    stateTaxMethod: string;
    code: string;
    addReducePayment: number;
    declaration: string;
    authorizationNote: string;
    // Add types for other data fields as needed
  };
  currentStep: number;
  goToStep: () => void;
};

function capitalizeFirstLetter(word: string): string {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

const RecentTransactionsModal = ({
  showRecentTransactionsModal,
  handleCloseRecentTransactionsModal,
  data,
}: RecentTransactionsModalProps) => {
  const {
    transactionType,
    confirmationNumber,
    submittedOn,
    createdVia,
    status,
    statusTooltipInfo,
    effective,
    planName,
    planType,
    taxableState,
    stateTaxMethod,
    code,
    addReducePayment,
    declaration,
    authorizationNote
  } = data;

  return (
    <Modal
      show={showRecentTransactionsModal}
      onHide={handleCloseRecentTransactionsModal}
      dialogClassName="modal-xl"
      className="custom-benefit-modal"
    >
      <ModalHeader closeButton withBorder>
        <h4 className="text-truncate">Transactions Details</h4>
      </ModalHeader>
      <ModalBody>
        <Container className="p-0">
          <Row>
            <Col className={'col-12 col-lg-9'}>
              <h5 className="pb-10">{transactionType}</h5>
            </Col>
            <Col
              className={
                'd-flex flex-column-reverse flex-lg-column col-12 col-lg-3 mt-7 mt-lg-0'
              }
            >
              <a
                className={'text-decoration-none'}
                href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
                target={'_blank'}
                rel="noreferrer"
              >
                <Button
                  leftIcon={light('file-download')}
                  variant="primary-outline"
                  className={'order-1 order-lg-3 w-100 mt-4 mt-lg-0'}
                  size="sm"
                >
                  Download/Print
                </Button>
              </a>
            </Col>
          </Row>

          <Row className="m-0 pt-3">
            <Col className="p-0 py-3 col-lg-4">
              <span className="text-fs-6 ps-4">Confirmation Number</span>
            </Col>
            <Col className="p-0 py-3 ps-5">
              <span className="text-fs-6 fw-bold">{confirmationNumber}</span>
            </Col>
          </Row>
          <Row className="m-0 pt-3">
            <Col className="p-0 py-3 col-lg-4">
              <span className="text-fs-6 ps-4">Submitted On</span>
            </Col>
            <Col className="p-0 py-3 ps-5">
              <span className="text-fs-6 fw-bold">{submittedOn}</span>
            </Col>
          </Row>
          <Row className="m-0 pt-3">
            <Col className="p-0 py-3 col-lg-4">
              <span className="text-fs-6 ps-4">Created Via</span>
            </Col>
            <Col className="p-0 py-3 ps-5">
              <span className="text-fs-6 fw-bold">{createdVia}</span>
            </Col>
          </Row>
          <Row className="m-0 pt-3">
            <Col className="p-0 py-3 col-lg-4">
              <span className="text-fs-6 ps-4">Status</span>
            </Col>
            <Col className="p-0 py-3 ps-5">
              <span className="text-fs-6 fw-bold">
                {capitalizeFirstLetter(status)}
              </span>
            </Col>
          </Row>
          <Row className="m-0 pt-3">
            <Col className="p-0 py-3 col-lg-4">
              <span className="text-fs-6 ps-4">Effective</span>
            </Col>
            <Col className="p-0 py-3 ps-5">
              <span className="text-fs-6 fw-bold">{effective}</span>
            </Col>
          </Row>

          <Row>
            <Container className="my-6 px-5 border-light-gray ">
              <Row className={' d-lg-flex py-3 bg-backgroud-gray border-bottom'}>
                <Col className={'col-12 ps-6 m-0 py-1'}>{transactionType}</Col>
              </Row>
              {planName && (
              <Row className={' d-lg-flex py-3 border-bottom'}>
                <Col className={'col-lg-4 ps-5 px-0 py-3 col'}><span className="text-fs-6">Plan</span></Col>
                <Col className={'p-0 py-3 ps-0'}>
                  <span className={'text-fs-6'}>{planName}</span>
                </Col>
              </Row>
              )}
              {planType && (
              <Row className={' d-lg-flex py-3 border-bottom '}>
                <Col className={'col-lg-4 ps-5 px-0 py-3 col'}><span className="text-fs-6">Type of Tax Witholding</span></Col>
                <Col className={'p-0 py-3 ps-0'}>
                  <span className={'text-fs-6'}>{planType}</span>
                </Col>
              </Row>
              )}
              {taxableState && (
              <Row className={' d-lg-flex py-3 border-bottom '}>
                <Col className={'col-lg-4 ps-5 px-0 py-3 col'}><span className="text-fs-6">Taxable State</span></Col>
                <Col className={'p-0 py-3 ps-0'}>
                  <span className={'text-fs-6'}>{taxableState}</span>
                </Col>
              </Row>
              )}
              {stateTaxMethod && (
              <Row className={' d-lg-flex py-3 border-bottom '}>
              <Col className={'col-lg-4 ps-5 px-0 py-3 col'}><span className="text-fs-6">State Tax Method</span></Col>
                <Col className={'p-0 py-3 ps-0'}>
                  <span className={'text-fs-6'}>{stateTaxMethod}</span>
                </Col>
              </Row>
              )}
              {code && (
              <Row className={' d-lg-flex py-3 border-bottom '}>
              <Col className={'col-lg-4 ps-5 px-0 py-3 col'}><span className="text-fs-6">Witholding Code</span></Col>
                <Col className={'p-0 py-3 ps-0'}>
                  <span className={'text-fs-6'}>{code}</span>
                </Col>
              </Row>
              )}
              {addReducePayment !== 0 && (
              <Row className={' d-lg-flex py-3 border-bottom '}>
              <Col className={'col-lg-4 ps-5 px-0 py-3 col'}><span className="text-fs-6">Additional or Reduced State Witholding per payment</span></Col>
                <Col className={'p-0 py-3 ps-0'}>
                  <span className={'text-fs-6'}>${addReducePayment.toFixed(2)}</span>
                </Col>
              </Row>
              )}
              {declaration && (
              <Row className={' d-lg-flex py-3'}>
              <Col className={'col-lg-4 ps-5 px-0 py-3 col'}><span className="text-fs-6">Declaration</span></Col>
                <Col className={'p-0 py-3 ps-0'}>
                  <span className={'text-fs-6'}>{declaration}</span>
                </Col>
              </Row>
              )}
            </Container>
          </Row>

          <Row>
            <Container className="px-7 py-5 list-cointainer">
              <p>{authorizationNote}</p>
            </Container>
          </Row>
        </Container>
        <section className="py-11 py-lg-12 d-flex justify-content-center flex-column flex-lg-row">
        <Button
          className="mt-7 mt-lg-0 me-lg-7 order-2 order-lg-1"
          variant="primary-outline"
          onMouseDown={handleCloseRecentTransactionsModal}
        >
          Close
        </Button>
      </section>
      </ModalBody>
    </Modal>
  );
};

export default RecentTransactionsModal;
